<template>
  <div>
    <span class="titleslight--text font-weight-medium">{{titulo}}</span>

    <div class=" my-2 pa-2">
      <div class="cont-input ">
        <div class="dropboxArchivo my-0 pa-2">
          <v-col>
            <p v-if="isMaximoFile" class="text--red"> Maximo de files exedido: {{NoAnexos}}</p>
            <v-row :justify="'center'" :align="'center'">
              <v-col cols="2" sm="2" :justify="'left'">
                <div class="icon-upload"><v-icon large>mdi-file-upload</v-icon> </div>
              </v-col>
              <v-col cols="4" md= "6" sm="6" :justify="'center'">
                <p class="text-medium"> <b>Arrastra y suelta aquí</b> tu archivo, o <span class="text-primary text-medium"><b>búscala en tu ordenador</b></span></p>
              </v-col>
            </v-row>
            <input :disabled="bCargando" v-bind="oAtributos" type="file" :multiple="NoAnexos > 1 ? true : false" ref="fileupload"
            @change="filesChange($event.target.files); fileCount = $event.target.files.length"
              :accept="extenAccept" class="input-file pa-0 ma-0">
          </v-col>
        </div>
      </div>

      <v-snackbar  v-model="isSnackBar" :timeout="3000">
        <p v-html="sMensaje"/>
      </v-snackbar>

      <v-row :justify="'center'">
        <v-col cols="6" sm="6" :align="'left'">
          <p class="texto-condicion"> Formatos permitidos: {{onMostrarExtensiones(extenAccept)}}</p>
        </v-col>
        <v-col cols="6" sm="6" :align="'right'">
          <p class="texto-condicion"> Tamaño Maximo por Archivo: {{nSizeFile/1024/1024}}MB</p>
        </v-col>
      </v-row>

      <hr v-if="aFiles.length>0">
      <v-list class="cont-listfiles">
        <v-list-item v-for="(archivos, key) in aFiles" :key="key" 
          :class='(archivos.bError) ? "archivo-error my-1 py-2 px-0 mx-0": "my-1 py-2 px-0 mx-0"'>
        <v-col>
           <v-row>
            <div class="archivo-avatar">
              <v-icon v-if="archivos.bError" max-width="65" class="mr-5 ml-5">mdi-information-outline</v-icon>
              <v-img v-else :src="archivos.sIcono"  class="mr-1 pa-3" contain></v-img>
            </div>

            <v-list-item-content>
              <template v-if="archivos.bError">
                <v-list-item-title class="red--text archivo-texto">{{ archivos.sMensajeError }}</v-list-item-title>
                <v-list-item-title class="red--text archivo-texto">{{ archivos.sNombre }} {{ onGetSize(archivos.oFile.size)}} MB</v-list-item-title>
              </template>
              <template v-else>
                <v-list-item-title class="archivo-texto">{{ archivos.sNombre }}</v-list-item-title>
                <v-list-item-title class="archivo-texto">{{ onGetSize(archivos.oFile.size)}} MB</v-list-item-title>
              </template>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn color="primary" x-small dense icon class="ml-auto font-weight-medium" @click="deletItem(key)"><v-icon class="text-h5 red--text">mdi-trash-can-outline</v-icon> </v-btn>
            </v-list-item-action>
           </v-row>
          <v-row class="px-0 mx-0">
            <div class="archivo-subiendo"  v-if="(archivos.nEstado == 2 || archivos.nEstado == 1)">
              <v-progress-linear
                :indeterminate = "archivos.nEstado == 1"
                color="#019578"
                :value="(archivos.nEstado == 2) ? 100 : 0"
              ></v-progress-linear>
            </div>
          </v-row>
        </v-col>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
  import mxFunciones from "@/mixins/funciones.js";
  import axiosServices from '@/services/axiosServices.js'
  import HoraFecha from '@/Utlidades/Hora_Fecha.js'
  const  isOK = 0, NoFileMaximo = 1

  export default {
    name: 'DragUpdatFile',
    mixins: [mxFunciones],
    props: {
      NoAnexos: {
        type: Number,
        default: 1
      },
      extenAccept: {
        type: String, 
        default: "image/*, application/pdf"
      },
      MaxTamanoFile: {
        type: Number,
        default: 0, // Tamaño en Bytes para cada archivo, Ej 1048576 (1MB), si el valor es 0 quiere decir que trabajara en base al valor del parametroGeneral sizeFileLoad
      },
      titulo:{
        type:String,
        default:''
      },
      bModoPrecargar:{  // Permite saber si se trabaja con la funcionalidad de ir subiendo los archivos desde el componente o no.
        type:Boolean,
        default:false
      },
      oAtributos:{
        type:Object,
        default:()=>{}
      }
    },
    data() {
      return {
        aFiles: [],
        uploadError: null,
        currentStatus: null,
        estatus : 0,
        nSizeFile : 0,
        sMensaje: '',
        isSnackBar: false,
        sTipoDocumentos: "application/vnd.openxmlformats-officedocument",
        sTipoDocumentosBIFF: "application/vnd.ms-excel",
        sTipoImagenes: "image/",
        sTipoComprimido: "application/zip",
        sTipoComprimido2: "application/x-zip-compressed",
        sTipoPdf: "application/pdf",
        sTipoTexto: "text/",
        sTipoAudio: "audio/",
        sTipoVideo: "video/",
        oConfAnexos: {},
        bCargando: false,
        sIconoDocs: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA0MiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjc3NTMgNTZIOC40MTc5NkM2LjE4MzcyIDU1Ljk5MjIgNC4wNDM1MSA1NS4wOTE0IDIuNDY1ODQgNTMuNDk0N0MwLjg4ODE2NiA1MS44OTggMC4wMDE1MjY1NCA0OS43MzU0IDAgNDcuNDgwNFY4LjUyNTQzQzAgNi4yNjQzNCAwLjg4OTk1MyA0LjA5NTg3IDIuNDc0MDggMi40OTcwNEM0LjA1ODIxIDAuODk4MjEyIDYuMjA2NzYgMCA4LjQ0NzA2IDBIMjkuNTczNEw0MS4yMTY1IDExLjgwOTlWNDcuNDgwNEM0MS4yMTUgNDkuNzM5NSA0MC4zMjUxIDUxLjkwNTYgMzguNzQyNCA1My41MDNDMzcuMTU5NyA1NS4xMDAzIDM1LjAxMzUgNTUuOTk4NCAzMi43NzUzIDU2WiIgZmlsbD0iIzUzODBDMCIvPgo8ZyBvcGFjaXR5PSIwLjUiPgo8cGF0aCBkPSJNNDEuMjIyMiAxMS43OThIMzEuOTcxOEMzMS4zNDI4IDExLjc5OCAzMC43Mzk2IDExLjU0NjIgMzAuMjk0MyAxMS4wOTc5QzI5Ljg0OTEgMTAuNjQ5NiAyOS41OTgyIDEwLjA0MTQgMjkuNTk2NiA5LjQwNjY0VjAuMDA1NzM3MyIgZmlsbD0id2hpdGUiLz4KPC9nPgo8cGF0aCBkPSJNMzQuMDg1IDIwLjk1ODFINy4xMTM3N1YyMi43MjA3SDM0LjA4NVYyMC45NTgxWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTM0LjA4NSAyNy4yOTE2SDcuMTEzNzdWMjkuMDU0MkgzNC4wODVWMjcuMjkxNloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zNC4wODUgMzMuNjMxOEg3LjExMzc3VjM1LjM5NDVIMzQuMDg1VjMzLjYzMThaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjAuNTk2NSAzOS45NjUzSDcuMTEzNzdWNDEuNzI4SDIwLjU5NjVWMzkuOTY1M1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==",
        sIconoPdf: "data:image/svg+xml;base64,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",
        sIconoComprimido: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA0MiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjc4MSA1Nkg4LjQ0MDk4QzYuMjAzMjggNTYgNC4wNTcxNSA1NS4xMDI1IDIuNDc0MzEgNTMuNTA0OEMwLjg5MTQ3NiA1MS45MDcgMC4wMDE1NDIxOCA0OS43Mzk4IDAgNDcuNDc5NVY4LjUyMDQ2QzAuMDAxNTQyMTggNi4yNjAxNSAwLjg5MTQ3NiA0LjA5Mjk1IDIuNDc0MzEgMi40OTUyMkM0LjA1NzE1IDAuODk3NDk3IDYuMjAzMjggLTUuMzY3ODhlLTA3IDguNDQwOTggMEgyOS41ODczTDQxLjIyMjEgMTEuODA1MlY0Ny40NzM3QzQxLjIyMjEgNDkuNzM1IDQwLjMzMjggNTEuOTAzNyAzOC43NDk4IDUzLjUwMjdDMzcuMTY2OCA1NS4xMDE3IDM1LjAxOTcgNTYgMzIuNzgxIDU2WiIgZmlsbD0iIzU5NkM4OSIvPgo8ZyBvcGFjaXR5PSIwLjUiPgo8cGF0aCBkPSJNNDEuMjIyMSAxMS44MDVIMzEuOTc4M0MzMS4zNDk4IDExLjgwNSAzMC43NDcgMTEuNTUzMiAzMC4zMDIgMTEuMTA0OEMyOS44NTcxIDEwLjY1NjUgMjkuNjA2MyAxMC4wNDgyIDI5LjYwNDcgOS40MTMzNlYwLjAxMTQ3NDYiIGZpbGw9IndoaXRlIi8+CjwvZz4KPHBhdGggZD0iTTE5Ljk3NjggMEgxNy4yNzE3VjIuNzMyNDJIMTkuOTc2OFYwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIyLjY4MTkgMi43MjU3N0gxOS45NzY4VjUuNDU4MTlIMjIuNjgxOVYyLjcyNTc3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE5Ljk3NjggNS40NTg0NEgxNy4yNzE3VjguMTkwODZIMTkuOTc2OFY1LjQ1ODQ0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIyLjY4MTkgOC4xOTExSDE5Ljk3NjhWMTAuOTIzNUgyMi42ODE5VjguMTkxMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOS45NzY4IDEwLjkyMzdIMTcuMjcxN1YxMy42NTYxSDE5Ljk3NjhWMTAuOTIzN1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMi42ODE5IDEzLjY1NTJIMTkuOTc2OFYxNi4zODc2SDIyLjY4MTlWMTMuNjU1MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOS45NzY4IDE2LjM4MjFIMTcuMjcxN1YxOS4xMTQ2SDE5Ljk3NjhWMTYuMzgyMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMi42ODE5IDE5LjExNDhIMTkuOTc2OFYyMS44NDcySDIyLjY4MTlWMTkuMTE0OFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOS45NzY4IDIxLjg0NzVIMTcuMjcxN1YyNC41Nzk5SDE5Ljk3NjhWMjEuODQ3NVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMi42ODE5IDI0LjU3OUgxOS45NzY4VjI3LjMxMTRIMjIuNjgxOVYyNC41NzlaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIuNjgxOSAyNy4zMDU4SDE3LjI3MTdWMzQuOTIxNEgyMi42ODE5VjI3LjMwNThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K",
        sIconoText: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA0MiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjc4MTEgNTZIOC40NDEwMUM2LjIwMzMgNTYgNC4wNTcxNiA1NS4xMDI2IDIuNDc0MzIgNTMuNTA1QzAuODkxNDc5IDUxLjkwNzUgMC4wMDE1NDIxOCA0OS43NDA1IDAgNDcuNDgwNFY4LjUyNTQzQzAgNi4yNjQzNCAwLjg4OTMyMyA0LjA5NTg3IDIuNDcyMzMgMi40OTcwNEM0LjA1NTM0IDAuODk4MjEyIDYuMjAyMyAwIDguNDQxMDEgMEgyOS41ODc0TDQxLjIyMjIgMTEuODA5OVY0Ny40ODA0QzQxLjIyMDcgNDkuNzQwNSA0MC4zMzA3IDUxLjkwNzUgMzguNzQ3OCA1My41MDVDMzcuMTY1IDU1LjEwMjYgMzUuMDE4OCA1NiAzMi43ODExIDU2WiIgZmlsbD0iIzAwQUM1NCIvPgo8ZyBvcGFjaXR5PSIwLjUiPgo8cGF0aCBkPSJNNDEuMjIyMiAxMS43OTgxSDMxLjk3ODNDMzEuMzQ5OCAxMS43OTgxIDMwLjc0NyAxMS41NDY0IDMwLjMwMiAxMS4wOTgxQzI5Ljg1NzEgMTAuNjQ5OCAyOS42MDYzIDEwLjA0MTUgMjkuNjA0NyA5LjQwNjc2VjAuMDA1ODU5MzgiIGZpbGw9IndoaXRlIi8+CjwvZz4KPHBhdGggZD0iTTMzLjQ3OTIgNDEuNzI4M0g3Ljc0MjkyVjIxLjE5OUgzMy40NzkyVjQxLjcyODNaTTkuNDg4MTUgMzkuOTY1NkgzMS43MzM5VjIyLjk2MTdIOS40ODgxNVYzOS45NjU2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE0Ljk2ODIgMjIuMDY4NkgxMy4yMjNWNDAuODQ2OUgxNC45NjgyVjIyLjA2ODZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMzIuNjEyNSAzNC42MDEySDguNjE1NlYzNi4zNjM5SDMyLjYxMjVWMzQuNjAxMloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMi42MTI1IDI3LjMxNTVIOC42MTU2VjI5LjA3ODJIMzIuNjEyNVYyNy4zMTU1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==",
        sIconoAudio: "data:image/svg+xml;base64,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"
      
      }
    },
    methods: {
      async reset() {
        // reset form to initial state
        this.aFiles = [];
        this.uploadError = null;

        this.nSizeFile = this.MaxTamanoFile
        // Si no se espeficia un tamaño personalizado, se trabajara por defecto con el valor del parametro general sizeFileLoad
        if(this.nSizeFile == 0) {
          await this.onCargarParametro()
        }
      },
      async onCargarParametro(){
        const axios_sizeFileLoad = await axiosServices.getConfiguration(`/generico/parametrogeneral/sizeFileLoad`, true  )
          if(axios_sizeFileLoad.nStatusCode == 200 && axios_sizeFileLoad.aData !== ''){
            this.nSizeFile = parseInt(axios_sizeFileLoad.aData.Valor)
          } else {
            this.$store.dispatch('notificaciones/SetMensaje',`Error: ${this.$store.state.jsIdioma.oEquivalencias.msgErrorParametro} : sizeFileLoad`);
            this.$store.dispatch('notificaciones/ShowNotificacion',true);    
          }
      },
      filesChange(fileList) {
        if((this.aFiles.length + fileList.length) > this.NoAnexos ){
          this.estatus = NoFileMaximo
          this.sMensaje = `Número de Anexo máximo superado, Maximo ${this.NoAnexos}`
          this.isSnackBar = true

        } else {
          // antes de guardar valido el tamaño de cada file
          this.onValidarArchivos(this.bModoPrecargar, fileList)
        }

        this.onNotificarCambios()
        this.$refs.fileupload.value = null
      },
      ValidarErrores(oitem) {
        //validar que el tipo del archivo se encuentre en la lista disponible
        let nombArchivo = oitem.name;
        var extension = nombArchivo.split(".").slice(-1);
            extension = extension[0];
        let extensiones = ['png','jpg', 'jpeg', 'jpeg', 'pdf', 'mp4','mp3','wav','docx', 'xml', 'csv', 'xlsx','xls'];

        if(extensiones.indexOf(extension) === -1){
          return 2;
        }

        if (oitem.size > this.nSizeFile){
          return 1
        }else {
          return 0
        }
      },
      deletItem(val){
        this.aFiles.splice(val,1)
        if(this.aFiles.length == 0){
          this.$refs.fileupload.value = null
        }
        this.onNotificarCambios()  
      },
      onMostrarExtensiones(sExtenciones){
      // Deveolvemos un String formateado de las Extensiones definidas para que sea mas legible al usuario
       return sExtenciones
              .replaceAll('.', '')
              .replaceAll('image/*', 'png, jpg, jpeg')
              .replaceAll('application/pdf', 'pdf')
              .toUpperCase()
      },
      onGetSize(nBytes){
       return (nBytes/1024/1024).toFixed(2)
      },
      onNotificarCambios(){
        this.$emit('files', Array.from(this.aFiles.filter((oArchivo) => !oArchivo.bError), (item) => item.oFile))
        this.$emit('input', Array.from(this.aFiles.filter((oArchivo) => !oArchivo.bError), (item) => item.oFile))
        this.$emit('onArchivosChange', Array.from(this.aFiles.filter((oArchivo) => !oArchivo.bError), (item) => item.oFile))
      },
      onValidarArchivos(bModoPrecargar, fileList){
        this.isSnackBar = false
        this.sMensaje = `Archivo(s) removido(s) por Tamaño superior a  ${this.nSizeFile/1024/1024}MB: <br>`
        if(fileList.length > 0){
          Object.keys(fileList).forEach((sKey, nIndex) =>{
            this.aFiles.push(this.onValidarArchivo(fileList[sKey], nIndex))
          })
        }
        if (bModoPrecargar) {  
          this.onSubirArchivos()
        }
        this.estatus = isOK
      },
      onValidarArchivo(oitem, nIndex=0) {
        var oArchivo = {
          sNombre:oitem.name,
          oFile:oitem,
          bError:false,
          sMensajeError: "",
          sIcono:"",
          nEstado:0 // 0-Pendiente Subir, 1-Subiendo- 2-Subido
        }
        //console.log("viejo", oitem);
        var sPrefijo = "";
        var bFormatoPermitido = false
        if (oitem.size > this.nSizeFile){
          oArchivo.bError = true
          oArchivo.sMensajeError =  `El archivo no debe tener un tamaño superior a  ${this.nSizeFile/1024/1024}MB`
        }else if(oitem.type.includes(this.sTipoImagenes)){
          //Si archivo es tipo Imagen validamos si no esta presente la condicion 'image/*' lo que implicaria que se definieron
          //extensiones especificas para las imagenes en FormulariosTablas(.jgp,.png, etc), si esta presente 'image/*' se deja cargar cualquier archivo tipo imagen
          if(!this.extenAccept.includes("image/*")){
            var aLista = this.extenAccept.split(',')
            //Si no esta presente la condicion 'image/*', obtenemos la lista de las extensiones definididas y vamos comparando cada combinacion 
            //para saber si la extension del archivo coincide con una
            aLista.forEach(sExtension => {
              if(oitem.type.includes("image/"+sExtension.trim().replace('.', ''))){
                bFormatoPermitido = true
              }
            });
            //Si despues de evaluar cada combinacion no existe alguna coincidencia ed formato, entonce el archivo tiene una extension no permitida
            if(!bFormatoPermitido){
              oArchivo.bError = true
              oArchivo.sMensajeError =  `El archivo debe ser en formato (${this.extenAccept.replaceAll('.', '').toUpperCase()})`
            }//Si despues de evaluar cada combinacion no existe alguna coincidencia ed formato, entonce el archivo tiene una extension no permitida
          }
          //Al ser una imagen obtenemos la miniatura para previsualizar
          oArchivo.sIcono = URL.createObjectURL(oitem)
          sPrefijo = "pic_"
        }
        else if(oitem.type.includes(this.sTipoDocumentos) || oitem.type.includes(this.sTipoDocumentosBIFF) || oitem.type.includes(this.sTipoPdf) || 
        oitem.type.includes(this.sTipoComprimido) || oitem.type.includes(this.sTipoComprimido2) || 
        oitem.type.includes(this.sTipoTexto) || oitem.type.includes(this.sTipoAudio) || oitem.type.includes(this.sTipoVideo)){
          //Para el caso de archivos difetentes a Imagen, hacemos la misma validacion iterando la lista de las extensiones definididas y 
          //vamos comparando cada combinacion para saber si la extension del archivo coincide con una
          var aExtension = oitem.name.split('.')
          aExtension.forEach(sExtension => {
            if(this.extenAccept.includes(sExtension.toLowerCase())){
              bFormatoPermitido = true
            }
          });
          if(!bFormatoPermitido){
            oArchivo.bError = true
            oArchivo.sMensajeError =  `El archivo debe ser en formato (${this.extenAccept.replaceAll('.', '').toUpperCase()})`
          }

          //Finalamente dependiendo del tipo de archivo asignamos el icono correspondiente
          if(oitem.type.includes(this.sTipoDocumentos) || oitem.type.includes(this.sTipoDocumentosBIFF)){
            oArchivo.sIcono = this.sIconoDocs
          }
          if(oitem.type.includes(this.sTipoPdf)){
            oArchivo.sIcono = this.sIconoPdf
          }
          if(oitem.type.includes(this.sTipoComprimido)){
            oArchivo.sIcono = this.sIconoComprimido
          }
          if(oitem.type.includes(this.sTipoComprimido2)){
            oArchivo.sIcono = this.sIconoComprimido
          }
          if(oitem.type.includes(this.sTipoAudio) || oitem.type.includes(this.sTipoVideo)){
            oArchivo.sIcono = this.sIconoAudio
          }
          if(oitem.type.includes(this.sTipoTexto)){
            oArchivo.sIcono = this.sIconoText
          }
          //sPrefijo = "file_"
        }
        else{
          oArchivo.bError = true
          oArchivo.sMensajeError =  `El archivo debe ser en formato (${this.extenAccept.replaceAll('.', '').toUpperCase()})`
        }
        if(!oArchivo.bError){ // Si el archivo no presenta error, cambiamos el nombre para cargar
          var sNombreNuevo = this.onGetNombreFinalArchivo(oitem, sPrefijo,`${HoraFecha.getNowFile()}${(nIndex+1)}`)
          oArchivo.oFile = this.onRenombrarArchivo(oitem, sNombreNuevo)
          oArchivo.sNombre = oArchivo.oFile.name
        }
        return oArchivo
      },
      async onSubirArchivos(){
        this.bCargando = true
        this.$emit('onArchivosSubiendo', this.bCargando)
        for (let index = 0; index < this.aFiles.length; index++) {
          if(!this.aFiles[index].bError && this.aFiles[index].nEstado==0){
            this.aFiles[index].nEstado = 1
            const resultado = await this.onSubirAnexo(this.aFiles[index].oFile)
            //Antes de indicar algo validamos si el item aun existe en la lista.
            if(this.aFiles[index]){
              if(resultado.nStatusCode === 200 || resultado.nStatusCode === 210){
                this.aFiles[index].nEstado = 2
              }else{
                this.aFiles[index].nEstado = 0
                this.aFiles[index].bError = true
                this.aFiles[index].sMensajeError = resultado.sMessage
              }
            }
          }
        }
        this.bCargando = false
        this.$emit('onArchivosSubiendo', this.bCargando)
        this.onNotificarCambios()
      },
      onGetNombreFinalArchivo(oFile, sPrefijo, sNombreBase){
        // Separar el nombre del archivo y su extensión
        const aNombreOriginal = oFile.name.split('.');
        const sExtension = aNombreOriginal.pop(); // saco el ultimo elemento que seria la extension
        var sNombreFinal = ""
        if(sPrefijo.includes("pic_")){
          sNombreFinal = `${sPrefijo}${sNombreBase}.${sExtension}`
        }else{
          sNombreFinal = aNombreOriginal[0].replaceAll(' ', '_')
          sNombreFinal = `${sNombreFinal}_${sNombreBase}.${sExtension}`
        }
        return sNombreFinal
      },
      onRenombrarArchivo(oFile, sNombreNuevo){
        return new File([oFile], sNombreNuevo, { type: oFile.type });
      }
    },
    computed: {
      CountArchivos() {
        let aux_count = 0
        this.aFiles.forEach(file =>  {
          aux_count += Object.keys(file).length
        })
        return aux_count
      },
      isMaximoFile() {
        return this.estatus === NoFileMaximo
      }
    },
    watch:{
      async MaxTamanoFile(newValue){
        this.nSizeFile = newValue
        // Si no se espeficia un tamaño personalizado, se trabajara por defecto con el valor del parametro general sizeFileLoad
        if(newValue == 0) {
          await this.onCargarParametro()
        }
      }
    },
    async mounted() {
      await this.reset();
    },
  }
</script>

<style lang="scss" >
  .cont-upfiles {
    border: 2px solid var(--v-blue_light-base);
    background: #F5FFFF;
    border-radius: 10px;
  }
  
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100px;
    top: 0px;
    left: 0px;
    position: absolute;
    cursor: pointer;
  }
  
  
  .list-unstyled {
    font-size: 0.8em;
    line-height: 1.1em;
    color: #424242;
    list-style: none;
    margin: 0!important;
    padding: 0!important;
    p{
      margin: 0px;
      padding: 0px;
    }
  }

.cont-listfiles{
  // border: solid blue;
  width: 100%;
}
.cont-input {
    border: 3px dotted gray;
    border-radius: 10px;
    padding: 8px;
  }
.archivo-error {
    color: dimgray;
    min-height: 60px; /* minimum height */
    position: relative;
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    background: #F5E4E3;
    width: 100%;

  
    i{
      color: #F96357 !important;
    }
    
  }

.archivo-avatar {
  max-height: 47px;
  max-width: 45px;
  min-width: 30px;
  width: 4%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: normal;
  position: relative;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
}

.archivo-texto {
  margin: 0 0 0 10px !important;
  text-align: left;
  padding: 0;
  font-size: 0.9em;
  line-height: 1.2em;
  transition: all ease-in-out 0.3s;
}

.archivo-subiendo{
  display: flex;
  flex: 1 1;
}
.dropboxArchivo {
    // outline: 2px dashed grey; /* the dash box */
    border: 1px solid var(--v-blue_light-base);
    border-radius: 10px;
    color: dimgray;
    min-height: 60px; /* minimum height */
    position: relative;
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    background: #D6E7F380;
    width: 100%;
    .icon-upload{
      margin: 0 auto;
      text-align: right;
      i{
        font-size: 45px !important;
      }
      
    }
    p {
      text-align: left;
      margin: 0;
      padding: 0;
      font-size: 1.0em;
      line-height: 1.5em;
      transition: all ease-in-out 0.3s;
      // color:var(--v-blue_light-base);
    }
  }
  .dropboxArchivo:hover {
    background: var(--v-primary-base); /* when mouse over to the drop zone, change color */
    .icon-upload{
      i{
      color: var(--v-blue_light-base);
      }
    }
    p{
      color:var(--v-blue_light-base);
    }

    b{
      color:white;
    }
  }

  .texto-condicion{
    color: #7E84A3;
    font-size: 1.0em;
    line-height: 1.2em;
  }


</style>
